module.exports = __webpack_public_path__ + "static/propel-d8c5fef455084b34e7c4ec51a570b8b2.jpg";